<template>
  <div class="vendor-table" v-if="users">
    <b-table
      :items="users"
      :fields="fields"
      responsive
      small
      :busy="loading"
    >
      <template #cell(isAdmin)="data">
        <b-form-checkbox
          v-model="data.item.isAdmin"
          aria-label="Is Admin"
          class="custom-success-checkbox"
          @input="onUpdateData(data.item)"
        />
      </template>

      <template #cell(isActive)="data">
        <b-form-checkbox
          v-model="data.item.isActive"
          aria-label="Is Active"
          class="custom-success-checkbox"
          @input="onUpdateData(data.item)"
        />
      </template>

      <template #cell(changePw)="data">
        <b-button variant="outline-info" size="sm" @click="changePw(data.item)">
          <span class="text-uppercase">Modifier Mots de Passe</span>
        </b-button>
      </template>

      <template #cell(actions)="data">
          <img  src="@/assets/icons/edit.svg" @click="onSelectedRow(data.item)" alt="User" height="25" class="mr-2" style="cursor: pointer;"/>
          <ConfirmAction @confirm="deleteUser(data.item.id)" />
      </template>

    </b-table>

    
    <div class="empty-state" v-if="loading || users.length === 0">
      <span class="text-danger">
        {{ loading ? 'Chargement en cours...' : 'Aucune donnée disponible' }}
      </span>
    </div>

    
    <pagination-controls
      :page="page"
      :page-size="pageSize"
      :total-items="total"
      @update:page="onPageChange($event)"
      @update:pageSize="onPageSizeChange($event)"
    />


  </div>
</template>

<script>
import PaginationControls from "@/components/common/customPagination.vue";
import ConfirmAction from "@/components/common/customConfirmAction.vue";
export default {
  components: { PaginationControls, ConfirmAction },
  props: {
    users: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    page: {
      type: Number,
      required: false,
      default: 1,
    },
    pageSize: {
      type: Number,
      required: false,
      default: 10,
    },
    total: {
      type: Number,
      required: false,
      default: 1,
    },
  },

  methods:{
    onPageChange(newPage) {
      this.$emit('update:page', newPage);
    },
    onPageSizeChange(newSize) {
      this.$emit('update:pageSize', newSize);
    },

    onSelectedRow(row) {
      this.$emit('update:row', row);
    },
    onUpdateData(data) {
      this.$emit('update:data', data);
    },

    changePw(row){
      this.$emit('update:password', row);
    }

  },

  data() {
    return {
      fields: [
        { key: 'name', label: 'Nom', tdClass: 'text-left font-weight-bold', thClass: 'text-left', tdAttr: { style: 'min-width:150px;' }, thAttr: { style: 'min-width:50px;' } },
        { key: 'username', label: 'Utilisateur', tdClass: 'text-left', thClass: 'text-left', tdAttr: { style: 'min-width:50px;' }, thAttr: { style: 'min-width:50px;' } },
        { key: 'changePw', label: '', tdClass: 'text-left', thClass: 'text-left', tdAttr: { style: 'min-width:220px;' }, thAttr: { style: 'min-width:50px;' } },
        { key: 'isActive', label: 'Actif', tdClass: 'text-center', thClass: 'text-center', tdAttr: { style: 'min-width:50px;' }, thAttr: { style: 'min-width:50px;' } },
        { key: 'isAdmin', label: 'Administateur', tdClass: 'text-center', thClass: 'text-center', tdAttr: { style: 'min-width:50px;' }, thAttr: { style: 'min-width:50px;' } },
        { key: 'actions', label: '', tdClass: 'text-right', thClass: 'text-right', tdAttr: { style: 'min-width:100px;' }, thAttr: { style: 'min-width:50px;' } },
      ],

    };
  },
};
</script>


<style scoped>
::v-deep .custom-success-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #28a745 !important; /* Bootstrap success green */
  border-color: #28a745 !important;
}

::v-deep .custom-success-checkbox .custom-control-input:checked:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40,167,69,.25) !important;
}
</style>